<template>
  <v-container fluid class="ma-0 pa-0">
    <v-row align-content="center" align="center" justify="center">
      <v-col cols="12" class="py-12">
        <v-container>
          <v-row>
            <v-col cols="12" lg="8">
              <div class="px-2">
                <div class="home-header-2 mt-6 mb-8">
                  FAQs
                </div>
                <div class="mb-12 home-text-2">
                  <p class="faq-question">
                    What if I can’t attend my appointment?
                  </p>
                  <p>
                    If you cannot attend your appointment you should cancel it so we can offer your appointment to another person.
                    You can view, change and cancel your appointments by logging into <a href="/booking/manage-my-appointments">Manage my appointments</a>.
                  </p>

                  <p class="faq-question">
                    What if I am unwell?
                  </p>
                  <p>
                    You can still receive a vaccine if you have a mild fever or upper airway infection, like a cold.
                    <br /><br />
                    If you are unwell, wait until you have recovered before having your vaccine. You should not attend a vaccine appointment if you think you could be infectious to others.
                  </p>

                  <p class="faq-question">
                    What do I need to bring with me?
                  </p>
                  <p>
                    If you are a Health and Social Care Worker, you must also bring your valid staff ID.
                    <br /><br />
                    If you are booking because you have received a formal letter from your GP/Consultant, you must bring this letter with you.
                    <br /><br />
                    If you have a booking for a Meningitis B vaccination, please bring an official email or letter or a screenshot from UCAS Hub providing confirmation of the offer of a place including the name of the university or college you are due to attend, the course code and/or title of the course of study.
                    <br />
                    If attending for Dose 2 of the MenB vaccine, please also bring your Meningococcal-B vaccination record card.
                  </p>

                  <p class="faq-question">
                    What should I expect when I arrive for my appointment?
                  </p>
                  <p>
                    Your vaccinator will check your details and ask you some questions for your safety before you get a vaccine – you should answer these as accurately as possible.
                    <br /><br />
                    If you are unable to answer these questions we may be unable to give a vaccine and referral back to your GP will be advised.
                    <br /><br />
                    If you are providing assistance, you may need to answer these questions for the person getting a vaccine.
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Faqs'
};
</script>

<style>
.faq-question {
  font-weight: bold;
}
</style>